import { environment } from './environment';

// Configurazione Firebase per Firestore - letta dai file environment
export const firebaseConfig = environment.firebase;

// Interfaccia per la configurazione Firebase
export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

// Funzione per verificare la configurazione Firebase
export function validateFirebaseConfig(config: FirebaseConfig): boolean {
  const requiredFields = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
  return requiredFields.every(field => config[field as keyof FirebaseConfig] && config[field as keyof FirebaseConfig] !== '');
}

// Funzione per ottenere informazioni sulla configurazione
export function getFirebaseConfigInfo(): { isValid: boolean; projectId: string; environment: string } {
  const isValid = validateFirebaseConfig(firebaseConfig);
  return {
    isValid,
    projectId: firebaseConfig.projectId,
    environment: environment.name
  };
}

// Configurazione Pub/Sub
export const pubSubConfig = {
  projectId: firebaseConfig.projectId,
  // In produzione, configurare le credenziali del servizio
  // keyFilename: 'path/to/service-account-key.json',
  // oppure
  // credentials: { client_email: '...', private_key: '...' }
  topics: {
    fascicoli: 'fascicoli',
    wizards: 'wizards',
    files: 'files',
    notifications: 'notifications',
    systemAlerts: 'system-alerts'
  },
  subscriptions: {
    fascicoli: 'fascicoli-sub',
    wizards: 'wizards-sub',
    files: 'files-sub',
    notifications: 'notifications-sub',
    systemAlerts: 'system-alerts-sub'
  }
};

// Funzione per validare la configurazione Pub/Sub
export function validatePubSubConfig(): boolean {
  return !!(pubSubConfig.projectId && pubSubConfig.projectId !== '');
}
